const enabledBuses = {
  google: true,
  facebook: true,
  gtm: true,
  clarity: true,
  moengage: true,
};

export default enabledBuses;
